export default api => {
	return {
		boot: `${api}/api/user-portal/boot`,
		contactUsBubble: `${api}/api/contact-us-bubble`,
	};
};
